var map = {
	"./BOU/recipe.png": "663f",
	"./DRU/recipe.png": "0c5f",
	"./FNB/recipe.png": "fc03",
	"./HIM/recipe.png": "d663",
	"./OTH/recipe.png": "e91d",
	"./SUP/recipe.png": "53ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aeda";